import React from 'react';
import SummaryCard from './SummaryCard';
import { List } from 'antd';
import TaskItem from '@/components/ProjectDetails/Cards/Items/TaskItem';
import { LeadTaskModel } from '@/typings/models/LeadTask';
import { F } from '@/utils/intl';
import FEATURE_FLAGS from '@/constants/featureFlags';
import { CheckAccess } from '@/utils/access';

export interface TasksCardProps {
  tasks: LeadTaskModel[];
  count: number;
  leadId: string;
  onAdd?: (e: MouseEvent) => void;
  onShowAll?: () => void;
  onRefresh?: () => void;
}

const TasksCard: React.FC<TasksCardProps> = ({
                                               tasks,
                                               count,
                                               leadId,
                                               onAdd,
                                               onShowAll,
                                               onRefresh,
                                             }) => {

  return (
    <CheckAccess feature={[FEATURE_FLAGS.LEAD_MANAGEMENT]}>
      <SummaryCard
        title={<F id={'pages.lead.tasks.openTasks'} defaultMessage={'Open Tasks'} />}
        count={count}
        onAdd={onAdd}
        onShowAll={onShowAll}
      >
        <List
          dataSource={tasks
            .filter((task) => !task.is_completed && !task.retired_at)
            .slice(0, 2)}
          renderItem={(task) => <TaskItem refresh={onRefresh} task={task} />}
        />
      </SummaryCard>
    </CheckAccess>
  );
};

export default TasksCard;
